module.exports = __webpack_public_path__ + "assets/img/ic-export-title.4dc12a7d.svg";